import React from "react";

import FirebaseAdapter from "@wc/adapters/firebase";

/**
 * Hook to get event reactions with real-time updates
 * @param {string} teamId The team ID
 * @param {string} eventId The event ID
 * @returns {{reactions: Array, loading: boolean, groupedReactions: object}} Reactions data
 */
export function useEventReactions(teamId, eventId) {
  const [reactions, setReactions] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (!teamId || !eventId) {
      setReactions([]);
      setLoading(false);
      return;
    }

    setLoading(true);

    try {
      const unsubscribe = FirebaseAdapter().reactions.subscribeToEventReactions(
        teamId,
        eventId,
        (reactionsData) => {
          setReactions(reactionsData);
          setLoading(false);
        },
      );

      return unsubscribe;
    } catch (err) {
      console.error("Failed to subscribe to reactions:", err);
      setLoading(false);
    }
  }, [teamId, eventId]);

  const groupedReactions = React.useMemo(() => {
    const groups = {};
    for (const reaction of reactions) {
      if (!groups[reaction.emoji]) {
        groups[reaction.emoji] = [];
      }
      groups[reaction.emoji].push(reaction);
    }
    return groups;
  }, [reactions]);

  return { reactions, loading, groupedReactions };
}
